import { FormSectionHandler } from '../entity.handler';
import { AssetUpdateRequest, CustomFieldValues, IdName } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField, FormBuilderGroup } from 'app/shared/components/form-builder';
import { EntityUtils } from '../utils';
import { get, set } from 'lodash';

interface EditorValues {
    [key: string]: any;
}

export class CustomFormGroupSectionHandler<T extends { id: string, assetType?: IdName, fields?: CustomFieldValues }> implements FormSectionHandler<T, EditorValues> {

    type = 'form';
    icon = 'sliders-v';
    bulk = true;

    title = this.form.name;
    description = this.form.description;

    constructor(
        public admin: AdminEditorService,
        public ownerId: string,
        public form: FormBuilderGroup,
        public valuesKey: string,
        public updateCallback: (_entity: T, _payload: any) => Promise<any>
    ) {
    }

    applyUpdate(entity: T, payload: any): Promise<any> {
        return this.updateCallback(entity, payload);

    }

    mapEntityToEditor(entity: T): Promise<EditorValues> {
        // add values or defaultValues from fields if no value is set yet
        const values = entity[this.valuesKey] || {};
        this.form.fields.forEach(field => {
            values[field.id] = values[field.id] || field.value || field.defaultValue;
        });
        return Promise.resolve({ ...(get(entity, this.valuesKey, {}) || {}) });
    }

    mapEditorToEntity(entity: AssetUpdateRequest, values: EditorValues): Promise<AssetUpdateRequest> {
        set(entity, this.valuesKey, values);
        return Promise.resolve(entity);
    }

    async getFields(entity: T): Promise<FormBuilderField[]> {
        const fields = [
            ...this.form.fields,
        ];
        return EntityUtils.prepareBulk(!entity, fields.map(x => x.id), fields);
    }

}
